import tansiqLogo from "@/assets/companies/tansiq-labs.svg";
import tuqneenLogo from "@/assets/companies/tuqneen.svg";
import silahLogo from "@/assets/companies/silah.svg";

export interface Venture {
  slug: string;
  name: string;
  logo: string;
  /** The venture's name, or its sound, in Arabic script. */
  arabic: string;
  /** Transliteration and meaning of the Arabic name, when it has one. */
  meaning?: { transliteration: string; gloss: string; root: string };
  sector: string;
  tagline: string;
  summary: string;
  story: string[];
  offerings: string[];
  url?: string;
  /** A quiet tint used for glows on the venture's own page. */
  tint: string;
}

export const ventures: Venture[] = [
  {
    slug: "tansiq-labs",
    name: "Tansiq Labs",
    logo: tansiqLogo,
    arabic: "تنسيق",
    meaning: { transliteration: "Tansīq", gloss: "arrangement; the harmony of parts", root: "ن س ق" },
    sector: "Software & Cybersecurity",
    tagline: "Advancing intelligence in code and craft.",
    summary:
      "Custom software, cybersecurity and cloud engineering for organisations that cannot afford to get it wrong.",
    story: [
      "Tansiq Labs is the software, cybersecurity and infrastructure company of Mashriqain Group. Its teams design and build custom software, secure it, and run it on infrastructure they understand end to end.",
      "Alongside client work, Tansiq operates its own platform services, from domains and virtual servers to DNS, uptime monitoring and bulk messaging, so that what it builds has a dependable home.",
    ],
    offerings: [
      "Custom software engineering",
      "Cybersecurity and assessment",
      "Cloud and DevOps",
      "Domains, VPS and DNS hosting",
      "Uptime monitoring",
      "Bulk SMS",
      "Credential vault",
      "Drone and UAV systems",
    ],
    url: "https://tansiqlabs.com",
    tint: "#7fa3c9",
  },
  {
    slug: "tuqneen",
    name: "Tuqneen",
    logo: tuqneenLogo,
    arabic: "تقنين",
    meaning: { transliteration: "Taqnīn", gloss: "to codify; to bring order by rule", root: "ق ن ن" },
    sector: "Education Technology",
    tagline: "Operations, simplified.",
    summary: "The operating platform for schools, madrasas, colleges and academies.",
    story: [
      "Tuqneen is the education technology company of Mashriqain Group. It brings an institution's daily operations into one calm, cloud-native platform: admissions and student records, fees and accounts, attendance, examinations, staff and payroll.",
      "It is built for the realities of education in Bangladesh, with national and madrasah grading, bKash and Nagad payments, and Bangla, English and Arabic, and it scales from a single campus to a network of branches.",
    ],
    offerings: [
      "Admissions and student records",
      "Fees, waivers and receipts",
      "Biometric and RFID attendance with SMS alerts",
      "Exams and report cards, national and madrasah",
      "Staff, leave and payroll",
      "Multi-campus oversight and analytics",
    ],
    url: "https://tuqneen.com",
    tint: "#3fb3a4",
  },
  {
    slug: "silah",
    name: "Silah",
    logo: silahLogo,
    arabic: "صلة",
    meaning: { transliteration: "Ṣilah", gloss: "a bond; that which joins", root: "و ص ل" },
    sector: "Customer Communication",
    tagline: "One place for every customer conversation.",
    summary: "Live chat, shared inboxes and AI-assisted support that connect businesses with their customers across channels.",
    story: [
      "Silah is the customer communication company of Mashriqain Group. It brings live chat, messaging channels and customer support into a shared workspace so teams can follow every conversation in one place.",
      "Its website chat widget, AI assistants, chatbots and team inbox help businesses answer questions, route conversations and hand over to a person when needed. Integrations and reporting connect support with the rest of a business.",
    ],
    offerings: [
      "Website live chat and chat widgets",
      "Shared team inbox and conversation routing",
      "AI-assisted customer support",
      "Chatbots and automated workflows",
      "Messaging channel integrations",
      "Customer support reporting",
    ],
    url: "https://silah.chat",
    tint: "#5fa883",
  },
];

export const findVenture = (slug: string | undefined) => ventures.find((v) => v.slug === slug);
